export const NAME = 'NAME' as const;
export const DESCRIPTION = 'DESCRIPTION' as const;
export const LEAD = 'LEAD' as const;
export const ISSUES = 'ISSUES' as const;

export type OrderField = typeof NAME | typeof DESCRIPTION | typeof LEAD | typeof ISSUES;

export const ORDER_FIELD = {
	[NAME]: NAME,
	[DESCRIPTION]: DESCRIPTION,
	[LEAD]: LEAD,
	[ISSUES]: ISSUES,
} as const;
